document.addEventListener('DOMContentLoaded', function () {
  var sections = document.querySelectorAll('[data-section-id][data-product-id][data-url]');
  sections.forEach(function (section) {
    var url = section.getAttribute('data-url');
    if (!url) return;

    fetch(url)
      .then(function (response) {
        return response.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var recommendations = doc.querySelector('.product-recommendations');
        if (recommendations && recommendations.innerHTML.trim().length) {
          section.innerHTML = recommendations.innerHTML;
          section.classList.remove('hide');
        }
      });
  });
});
